export default {
      id: "ic-plan-sac-poubelle-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-plan-sac-poubelle-usage",
      toString: function () {
        return this.url;
      }
    }